/**
* To store the boolean value into website local storage
* @param localKey: It is to store the key of local storage
* @param convertBoolean: It is to store the value of local storage
*/

import {
  getEncryptedCacheStorage,
  setEncryptedCacheStorage,
  deleteCacheStorage
} from "@sentara-health/cachestorage";

export const setLocalStorageBoolean = (localKey: string, convertBoolean: boolean) => {
    localStorage.setItem(localKey, convertBoolean.toString());
  }
  
  /**
  * To get the boolean value from to pass key of the local storage
  * @param localKey: It is to get the key of local storage
  * @returns
  */
  
  export const getLocalStorageBoolean = (localKey: string) => {
    return stringToBoolean(localStorage.getItem(localKey) ?? 'false' )
  }

  function stringToBoolean(val: string) {
    try {
      return !!JSON.parse(String(val).toLowerCase());
    } catch (e) {
      console.error("[LocalStorageUtils] Failed to parse:", e);
      return false;
    }
  }

export const getLocalStorageString = (value: string) => {
  return localStorage.getItem(value) ?? '';
};

/**
* To store the boolean value into website Session storage
* @param localKey: It is to store the key of Session storage
* @param convertBoolean: It is to store the value of Session storage
*/
export const setSessionStorageBoolean = (localKey: string, convertBoolean: boolean) => {
  sessionStorage.setItem(localKey, convertBoolean.toString());
}

/**
* To get the boolean value from to pass key of the Session storage
* @param localKey: It is to get the key of Session storage
* @returns
*/ 
export const getSessionStorageBoolean = (localKey: string) => {
  return stringToBoolean(sessionStorage.getItem(localKey) ?? 'false')
}

/**
  * To encrypt the  value  and set in cache storage
  * @param localKey: It is to set the key of cache storage
  * @param value: It is to set the value of cache storage for specified key
  * @param timeStamp: TimeStamp
  * @returns
*/
  export const setEncryptedValue = async (localKey: string, value:string, timeStamp:number=60): Promise<void> => {
    await setEncryptedCacheStorage(localKey, value, timeStamp, process.env.REACT_APP_SECRET_PASS as string);
  }

/**
  * To get the decrypted value from cache storage
  * @param localKey: It is to get the decrypted cache storage value
  * @returns the decrypted cache storage value based on the localkey
*/
export const getDecryptedValue = async (localKey: string): Promise<any> => {
  // console.log("[LocalStorageUtils] READ START for key:", localKey, "at", Date.now());
  try {
    let response  = await getEncryptedCacheStorage<string>(localKey, process.env.REACT_APP_SECRET_PASS as string);
    return response?.data;
  } catch (error) {
    return null;
  }
}

/**
  * To delete all the value from cache storage
  * @return void
*/
export const deleteEncryptedValue =  ():void => {
  deleteCacheStorage()
}



  
